import { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Lock, Sparkles, Check } from 'lucide-react';
import { useOrgPlan } from '@/hooks/useOrgPlan';
import { useEnterpriseLicenseStats } from '@/hooks/useEnterpriseLicenseStats';
import { RequestEnterpriseLicensesDialog } from '@/components/admin/RequestEnterpriseLicensesDialog';

interface UpgradePlanDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  moduleName?: string;
}

const BENEFITS = [
  'Inventario de IA y fichas de cada herramienta',
  'Gestión de Riesgos con controles y seguimiento',
  'Centro de Excelencia de IA (roles, políticas y procesos)',
  'Gestión del Cambio y medición de adopción',
  'Auditoría de conversaciones de IA',
  'Usuarios ilimitados para tu equipo',
];

export function UpgradePlanDialog({ open, onOpenChange, moduleName }: UpgradePlanDialogProps) {
  const { organizationId } = useOrgPlan();
  const { data: stats } = useEnterpriseLicenseStats(organizationId);
  const [requestOpen, setRequestOpen] = useState(false);

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-2">
              <Lock className="w-6 h-6 text-primary" />
            </div>
            <DialogTitle>
              {moduleName ? `${moduleName} está en el plan empresarial` : 'Disponible en el plan empresarial'}
            </DialogTitle>
            <DialogDescription>
              Tu empresa está en el plan gratuito. Mejora de plan para desbloquear todos los módulos de
              gestión y gobierno de IA.
            </DialogDescription>
          </DialogHeader>

          <ul className="space-y-2 py-2">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-2 text-sm text-muted-foreground">
                <Check className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                <span>{b}</span>
              </li>
            ))}
          </ul>

          <DialogFooter className="gap-2 sm:gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Ahora no
            </Button>
            <Button
              className="gap-2"
              onClick={() => {
                onOpenChange(false);
                setRequestOpen(true);
              }}
            >
              <Sparkles className="w-4 h-4" />
              Quiero mejorar de plan
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <RequestEnterpriseLicensesDialog
        open={requestOpen}
        onOpenChange={setRequestOpen}
        orgName={stats?.organizationName ?? undefined}
        used={stats?.used ?? 0}
        max={stats?.max ?? 0}
      />
    </>
  );
}

export default UpgradePlanDialog;
